<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card p-2" [formGroup]="masterDataForm">
            <div class="row">
              <div class="col-12">
                <h3>{{ "MENU.EXTERNAL_USERS_LIST" | translate }}</h3>
              </div>
            </div>
            <div class="row pt-2">
              <div class="form-group col-lg-6">
                <fieldset class="form-group">
                  <label for="logo">{{ "LOGO" | translate }}</label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="logo" accept="image/*" (change)="handlerChangeFileInput($event)" />
                    <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="name">{{ "NAME" | translate }}:<sup class="text-danger">*</sup></label>
                <input type="text" id="name" class="form-control {{ masterDataHasError('name') ? 'is-invalid' : '' }}" formControlName="name" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.name.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.name?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.name?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="business_name">{{ "BUSINESS_NAME" | translate }}:<sup class="text-danger">*</sup></label>
                <input type="text" id="business_name" class="form-control {{ masterDataHasError('business_name') ? 'is-invalid' : '' }}" formControlName="business_name" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.business_name.errors?.required">{{ "ERRORS.FIELD_BUSINESS_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.business_name?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.business_name?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="vat_number">{{ "VAT_NUMBER" | translate }}</label>
                <input type="text" id="vat_number" class="form-control {{ masterDataHasError('vat_number') ? 'is-invalid' : '' }}" formControlName="vat_number" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.vat_number.errors?.required">{{ "ERRORS.FIELD_VAT_NUMBER" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.vat_number?.errors?.minlength">{{ "MIN" | translate }} 9 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.vat_number?.errors?.maxlength">{{ "MAX" | translate }} 12 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="fiscalcode">{{ "FISCAL_CODE" | translate }}:</label>
                <input type="text" id="fiscalcode" class="form-control" formControlName="fiscalcode" />
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="bank">{{ "BANK" | translate }}:<sup class="text-danger">*</sup></label>
                <ng-select
                  id="bank"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="bank"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ masterDataHasError('bank') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="banksList"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.bank.errors?.required">{{ "ERRORS.FIELD_BANK" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="email">{{ "EMAIL" | translate }}:</label>
                <input type="text" id="email" class="form-control {{ masterDataHasError('email') ? 'is-invalid' : '' }}" formControlName="email" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.email?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.email?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="pec">{{ "PEC" | translate }}:</label>
                <input type="text" id="pec" class="form-control {{ masterDataHasError('pec') ? 'is-invalid' : '' }}" formControlName="pec" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.pec?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.pec?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.pec?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="recipient_pec">{{ "RECIPIENT_PEC" | translate }}:</label>
                <input type="text" id="recipient_pec" class="form-control {{ masterDataHasError('recipient_pec') ? 'is-invalid' : '' }}" formControlName="recipient_pec" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.recipient_pec?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.recipient_pec?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.recipient_pec?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="col-lg-6 col-12">
                <label for="invoice_type">{{ "INVOICE_TYPE" | translate }}:<sup class="text-danger">*</sup></label>
                <ng-select
                  id="invoice_type"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="invoice_type"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ masterDataHasError('invoice_type') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="invoiceTypeList"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.invoice_type.errors?.required">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="unique_code">{{ "UNIQUE_CODE" | translate }}:</label>
                <input type="text" id="unique_code" class="form-control" formControlName="unique_code" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button type="button" class="btn btn-primary" (click)="save()">{{ "SAVE" | translate }}</button>
        </div>
      </div>
    </section>
  </div>
</div>
